import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/uaUltra.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/access-ultra.jpg";
import type { Product } from "../../types";
import { controlHubs } from "../product-list-groups/controlHubs";
import {
  accessPowerMethod,
  inputTerminals,
  outputRelays,
  poePorts,
  powerRedundancy,
} from "../properties";

export const uaUltra: Product = {
  id: "uaUltra",
  productTitle: "Access Ultra",
  productListGroup: controlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-ultra"],
  storePathParts: {
    productSlug: "ua-ultra",
    category: UniFiChildCategorySlug.DoorAccessHub,
  },
  sku: "UA-Ultra",
  description: "uaUltra.description",
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 257,
    height: 182,
  },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '126 x 45 x 37.45 mm\n(4.9 x 1.8 x 4.5")',
      },
    },
    {
      propertyId: outputRelays.id,
      value: {
        type: "translation",
        value: "uaUltra.outputRelays",
      },
    },
    {
      propertyId: inputTerminals.id,
      value: {
        type: "translation",
        value: "uaUltra.inputTerminal",
      },
    },
    {
      propertyId: poePorts.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: accessPowerMethod.id,
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: powerRedundancy.id,
      value: { type: "boolean", value: false },
    },
  ],
};
